<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      screenWidth: document.body.clientWidth, //屏幕可视区宽度
    };
  },
  created() {
    // this.resetrem();
    // //切换屏幕 （横屏竖屏）
    // window.addEventListener("orientationchange", this.resetrem());
    // //resize：屏幕的大小发生改变就触发监听事件resetrem
    // window.addEventListener("resize",this.resetrem());
  },
  mounted() {
    // 监听窗口变化
    let _this = this;
    window.addEventListener("resize", function () {
      _this.resetrem();
    });
    window.addEventListener("orientationchange", _this.resetrem());
  },
  watch: {
    // 窗口宽度改变
    screenWidth(n, o) {
      this.resetrem();
    },
  },
  methods: {
    resetrem() {
      //判断设备
      // const isMobile = navigator.userAgent.match(
      //   /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      // );

      var html = document.querySelector("html"); //获取到html元素
      var width = html.getBoundingClientRect().width; //获取屏幕的宽度
      if (width < 768) {
        width = width / 100;
      } else {
        // (width * 0.85) / 120
        // width = (width / 100) * 0.734;
        width = width / 100;
        // pc:2726 / 20
        if (width < 12.4) {
          width = 12.4;
        }
      }
      html.style.fontSize = width + "px";
    },
  },
};
</script>

<style lang="less">
#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif; */
}
@media all and (min-width: 768px) {
  html,
  body {
    margin: 0;
    padding: 0;
    list-style: none;
    min-width: 1000px;
  }
}

@media all and (max-width: 767px) {
  html,
  body {
    margin: 0;
    padding: 0;
    list-style: none;
  }
}
.clickMouse {
  cursor: pointer;
}
* {
  margin: 0;
  padding: 0;
  // font-family: Source Han Sans CN, "思源黑体 Normal", "思源黑体 Medium",
  //   "思源黑体 Bold", Helvetica;
  font-family: Arial, Helvetica, sans-serif !important;
  /* cursor: pointer; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue